import { URSSAF } from '@/utils/logos'

// TODO: gérer les traductions
export const premiersMoisUrssaf = {
	url: 'https://www.urssaf.fr/accueil/services/services-independants/mespremiersmois.html',
	title: 'Mes premiers mois avec l’Urssaf',
	description:
		'Un accompagnement tout au long des étapes clés de votre première année d’entrepreneuriat, pour réussir le lancement de votre entreprise.',
	logo: URSSAF,
}
